import { render, staticRenderFns } from "./ExportFile.vue?vue&type=template&id=4bdf1c4e"
import script from "./ExportFile.vue?vue&type=script&lang=js"
export * from "./ExportFile.vue?vue&type=script&lang=js"
import style0 from "./ExportFile.vue?vue&type=style&index=0&id=4bdf1c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports